import { gql } from "@apollo/client";

import assessmentFormAnswerFragment from "./assessment-form-answer-fragment";

// Loads the saved answers again after Claude, ChatGPT or Ask AI saved one (TF-1786).
export default gql`
  ${assessmentFormAnswerFragment}
  query GetAssessmentAnswers($assessmentId: Int!) {
    assessment(assessmentId: $assessmentId) {
      id
      answers {
        ...AssessmentFormAnswer
      }
    }
  }
`;
